import api from '@/services/api'
import SecurityMarkActions from './actions-types'

export default {
  [SecurityMarkActions.SAVE_SECURITY_MARK]({ state }, securityGroup) {
    return new Promise((resolve, reject) => {
      let data = {}

      state.fields.forEach((item) => {
        data[item.name] = item.value
      })

      data['security_group_id'] = securityGroup.security_group_id

      const secMarkId = state.selectedSecurityMark
        ? (state.selectedSecurityMark.security_mark_id ?? state.selectedSecurityMark.id)
        : null
      const parentMarkId = state.selectedParentMark
        ? (state.selectedParentMark.security_mark_id ?? state.selectedParentMark.id)
        : null

      // A parent is selected only by the "create child" flow. In particular,
      // never include it in an update: modal state is shared in Vuex and a
      // cancelled child modal must not be able to change an existing mark.
      if (
        secMarkId == null &&
        securityGroup.match_type == 'tree' &&
        parentMarkId != null
      ) {
        data['mark_parent'] = parentMarkId
      }

      if (secMarkId != null) {

        api.node.security
          .updateSecurityMark(data, secMarkId)
          .then((response) => {
            resolve(response.body)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      } else {
        api.node.security
          .createSecurityMark(data)
          .then((response) => {
            resolve(response.body)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      }
    })
  },

  [SecurityMarkActions.DELETE_SECURITY_MARK]({ state }) {
    return new Promise((resolve, reject) => {
        api.node.security
          .deleteSecurityMark(state.selectedSecurityMark.security_mark_id ?? state.selectedSecurityMark.id)
          .then((response) => {
            resolve(response.body)
          })
          .catch((error) => {
            reject(error.response.data)
          })
    })
  },
}
